import { getUser } from "./APIUtility";

// 1. create_case_study(name, description, username)
export const createCaseStudyAPI = async (formData) => {
    const username = await getUser()
    formData.append("username", username);
    try {
        const response = await fetch(
            `${process.env.REACT_APP_FASTAPI_URL}/create_case_study`,
            {
                method: "POST",
                body: formData,
            }
        );

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        return data;
    } catch (error) {
        throw new Error(`Error in Create Case Study: ${error.message}`);
    }
};
// 2. update_case_study(name, description, files, linked_project_id, associated_project_id)
export const updateCaseStudyDetailsAPI = async (formData) => {
    try {
        const response = await fetch(
            `${process.env.REACT_APP_FASTAPI_URL}/update_case_study`,
            {
                method: "POST",
                body: formData,
            }
        );

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        return data;
    } catch (error) {
        throw new Error(`Error in Update Case Study: ${error.message}`);
    }
};
// 3. delete_case_study(case_study_id)
export const deleteCaseStudyAPI = async (formData) => {
    const username = await getUser()
    formData.append("username", username);
    try {
        const response = await fetch(
            `${process.env.REACT_APP_FASTAPI_URL}/delete_case_study`,
            {
                method: "POST",
                body: formData,
            }
        );

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        return data;
    } catch (error) {
        throw new Error(`Error in Delete Case Study: ${error.message}`);
    }
};
// 4. get_case_study(case_study_id)
export const getCaseStudyAPI = async (formData) => {
    try {
        const response = await fetch(
            `${process.env.REACT_APP_FASTAPI_URL}/get_case_study`,
            {
                method: "POST",
                body: formData,
            }
        );

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        return data;
    } catch (error) {
        throw new Error(`Error in Get Case Study: ${error.message}`);
    }
};
// 5. get_all_case_studies(username)
export const getAllCaseStudiesAPI = async () => {
    const username = await getUser()
    const formData = new FormData();
    formData.append("username", username);
    try {
        const response = await fetch(
            `${process.env.REACT_APP_FASTAPI_URL}/get_all_case_studies`,
            {
                method: "POST",
                body: formData,
            }
        );

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        return data;
    } catch (error) {
        throw new Error(`Error in Get All Case Studies: ${error.message}`);
    }
};
// 6. background_step(case_study_id)
export const backgroundStepAPI = async (formData) => {
    const username = await getUser()
    formData.append("username", username);
    try {
        const response = await fetch(
            `${process.env.REACT_APP_FASTAPI_URL}/background_step`,
            {
                method: "POST",
                body: formData,
            }
        );

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        return data;
    } catch (error) {
        throw new Error(`Error in Background Step: ${error.message}`);
    }
};
// 7. ideation_step(case_study_id)
export const ideationStepAPI = async (formData) => {
    const username = await getUser()
    formData.append("username", username);
    try {
        const response = await fetch(
            `${process.env.REACT_APP_FASTAPI_URL}/ideation_step`,
            {
                method: "POST",
                body: formData,
            }
        );

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        return data;
    } catch (error) {
        throw new Error(`Error in Ideation Step: ${error.message}`);
    }
};
// 8. research_step(case_study_id)
export const researchStepAPI = async (formData) => {
    const username = await getUser()
    formData.append("username", username);
    try {
        const response = await fetch(
            `${process.env.REACT_APP_FASTAPI_URL}/research_step`,
            {
                method: "POST",
                body: formData,
            }
        );

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        return data;
    } catch (error) {
        throw new Error(`Error in Research Step: ${error.message}`);
    }
};
// 9. generation_step(case_study_id)
export const draftStepAPI = async (formData) => {
    const username = await getUser()
    formData.append("username", username);
    try {
        const response = await fetch(
            `${process.env.REACT_APP_FASTAPI_URL}/generation_step`,
            {
                method: "POST",
                body: formData,
            }
        );

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        return data;
    } catch (error) {
        throw new Error(`Error in Generation Step: ${error.message}`);
    }
};
// 10. clone_case_study(case_study_id)
export const cloneCaseStudyAPI = async (formData) => {
    const username = await getUser()
    formData.append("username", username);
    try {
        const response = await fetch(
            `${process.env.REACT_APP_FASTAPI_URL}/clone_case_study`,
            {
                method: "POST",
                body: formData,
            }
        );

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        return data;
    } catch (error) {
        throw new Error(`Error in Clone Case Study: ${error.message}`);
    }
};
// 11. add_tags(case_study_id, tags)
export const addTagsAPI = async (formData) => {
    const username = await getUser()
    formData.append("username", username);
    try {
        const response = await fetch(
            `${process.env.REACT_APP_FASTAPI_URL}/add_tags`,
            {
                method: "POST",
                body: formData,
            }
        );

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        return data;
    } catch (error) {
        throw new Error(`Error in Add Tags: ${error.message}`);
    }
};


export const uploadFileCaseStudyAPI = async (caseStudyId, file) => {
    const form = new FormData();
    form.append("files", file);
    const res = await fetch(
        `${process.env.REACT_APP_FASTAPI_URL}/upload_file_case_study/${encodeURIComponent(caseStudyId)}`,
        { method: "POST", body: form }
    );
    if (!res.ok) {
        const msg = await res.text().catch(() => "");
        throw new Error(`HTTP ${res.status}: ${msg || res.statusText}`);
    }
    return await res.json();
};

export const deleteUploadedFileCaseStudyAPI = async (caseStudyId, fileId) => {
    const formData = new FormData();
    formData.append("case_study_id", caseStudyId);
    formData.append("file_id", fileId);
    const res = await fetch(
        `${process.env.REACT_APP_FASTAPI_URL}/delete_uploaded_file_case_study`,
        { method: "POST", body: formData }
    );
    if (!res.ok) {
        const msg = await res.text().catch(() => "");
        throw new Error(`HTTP ${res.status}: ${msg || res.statusText}`);
    }
    return await res.json();
};

export const saveBackgroundAPI = async (formData) => {
    try {
        const response = await fetch(
            `${process.env.REACT_APP_FASTAPI_URL}/save_background`,
            {
                method: "POST",
                body: formData,
            }
        );

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        return data;
    } catch (error) {
        throw new Error(`Error in Save Background: ${error.message}`);
    }
};

export const saveDraftAPI = async (formData) => {
    try {
        const response = await fetch(
            `${process.env.REACT_APP_FASTAPI_URL}/save_draft`,
            {
                method: "POST",
                body: formData,
            }
        );

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        return data;
    } catch (error) {
        throw new Error(`Error in Save Draft: ${error.message}`);
    }
};


export const saveTeachingNoteAPI = async (formData) => {
    try {
        const response = await fetch(
            `${process.env.REACT_APP_FASTAPI_URL}/save_teaching_note`,
            {
                method: "POST",
                body: formData,
            }
        );

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        return data;
    } catch (error) {
        throw new Error(`Error in Save Draft: ${error.message}`);
    }
};


export const saveLabDetailsAPI = async (formData) => {
    try {
        const response = await fetch(
            `${process.env.REACT_APP_FASTAPI_URL}/save_lab_details`,
            {
                method: "POST",
                body: formData,
            }
        );

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        return data;
    } catch (error) {
        throw new Error(`Error in Save Draft: ${error.message}`);
    }
};

export const saveIdeationAPI = async (formData) => {
    try {
        const response = await fetch(
            `${process.env.REACT_APP_FASTAPI_URL}/save_ideation`,
            {
                method: "POST",
                body: formData,
            }
        );

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        return data;
    } catch (error) {
        throw new Error(`Error in Save Ideation: ${error.message}`);
    }
};

export const saveResearchAPI = async (formData) => {
    try {
        const response = await fetch(
            `${process.env.REACT_APP_FASTAPI_URL}/save_research`,
            {
                method: "POST",
                body: formData,
            }
        );

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        return data;
    } catch (error) {
        throw new Error(`Error in Save Research: ${error.message}`);
    }
};
